module.exports = __webpack_public_path__ + "static/img/MX.6eea7a50.jpg";